module.exports = __webpack_public_path__ + "static/portrait-440dbda20d302c07d56734826a773bdc.png";